
const ContactSnippet = () => {
  return (
    <section className="py-12 bg-[#0A2647]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-phone-fill text-2xl text-[#2196F3]"></i>
            </div>
            <div>
              <p className="text-white/70 text-sm mb-1">Call Us Today</p>
              <a 
                href="tel:512-306-6245" 
                className="text-white text-xl md:text-2xl font-bold hover:text-[#2196F3] transition-colors cursor-pointer"
              >
                512-306-6245
              </a>
            </div>
          </div>
          
          <div className="hidden md:block w-px h-16 bg-white/20"></div>
          
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-map-pin-fill text-2xl text-[#2196F3]"></i>
            </div>
            <div>
              <p className="text-white/70 text-sm mb-1">Visit Our Office</p>
              <a 
                href="https://maps.google.com/?q=8708+S+Congress+Ave,+Austin,+TX+78745" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white text-xl md:text-2xl font-bold hover:text-[#2196F3] transition-colors cursor-pointer"
              >
                8708 S Congress Ave, Austin, TX 78745
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSnippet;
